import { Component, ElementRef, ViewChild, OnInit, Host, ChangeDetectorRef } from '@angular/core';
import { OutboxService } from 'src/app/shared/services/outbox/outbox.service';
import { HttpClient } from '@angular/common/http';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { environment } from 'src/environments/environment';
import { OutboxRequestCreationComponent } from '../outbox-request-creation.component';
import * as _ from 'lodash';
import { FormsModule } from '@angular/forms';
import { NgIf, NgClass, NgFor } from '@angular/common';
import { ReCaptchaV3Service } from 'ng-recaptcha-2';

@Component({
    selector: 'app-outbox-single-request-creation',
    templateUrl: './outbox-single-request-creation.component.html',
    styleUrl: './outbox-single-request-creation.component.scss',
    imports: [FormsModule, NgIf, NgClass, NgFor]
})
export class OutboxSingleRequestCreationComponent implements OnInit {
  @ViewChild('name') nameRef!: ElementRef;
  @ViewChild('mobileSMS') mobileSMSRef!: ElementRef;
  @ViewChild('mobileWA') mobileWARef!: ElementRef;
  @ViewChild('email') emailRef!: ElementRef;
  @ViewChild('sameNumberWA') sameNumberWARef!: ElementRef;
  customTagMsg = "Only English characters (A-Z, a-z), numbers (0-9), and these special characters are allowed in Custom tag data: ! @ # $ % ^ & ( ) _ { } : “ ? ` - ‘ , . / \\\"";
  placeholder = "Select a tag parameter"
  dropdownFocusState: { [header: string]: boolean } = {};
  selectedCountryPattern: string = "[0-9]{10}"; // Default 10-digit number pattern
  selectedCountry: any = { name: "India", code: "IN", dial_code: "+91" }; // Default country
  selectedCountrySMS: any = { "name": "India", "code": "IN", "dial_code": "+91", "pattern": "^\\d{10}$", "max_limit": 10 }; // Variable for SMS selected country
  selectedCountryWA: any = { "name": "India", "code": "IN", "dial_code": "+91", "pattern": "^\\d{10}$", "max_limit": 10 };  // Variable for WhatsApp selected country
  countries: any[] = [];
  selectedRequestChannels: string[] = ['SMS', 'Email', 'WA'];
  touchpointOptions: string[] = []; // Will be populated dynamically
  transactionDatas: { tagName: string, tagValue: string }[] = [{ tagName: '', tagValue: '' }];
  customTags: { tagName: string; tagValue: string }[] = [{ tagName: '', tagValue: '' }];
  showDropdown: boolean[] = [];
  tagLength: any;
  selectedTags: any;
  brandDetails = Helpers.brandDetails;
  filtered_custom_tags: any
  brandId: any;
  params = {}
  shopId: any;
  isFormValid: boolean = false;
  mobileNumberError: string = ''; // To store mobile validation message
  whatsappNumberError: string = '';
  emailError: string = ''; // To store email validation message
  isExcludedFromStatistics: boolean = false;
  // to add all form field required for request creation api
  isRestrictedSpecialCharacter = false;
  isTagDataEnglish = true;
  app_id = ""
  nameError: string = '';
  request_mode : string ="single_request";
  formData = {
    isSameNumberWA: false
  }

  constructor(
    private cdRef: ChangeDetectorRef,
    private _outboxService: OutboxService,
    private http: HttpClient,
    private _utilsService: UtilsService,
    private _helpers: HelpersService,
    private _toast: ToastService,
    private recaptchaV3Service: ReCaptchaV3Service,
    @Host() private requestCreationComponent: OutboxRequestCreationComponent
  ) { }

  ngOnInit() {
  this.isFormValid = false
    const filteredTags = Object.values(this.brandDetails.field_definitions as Record<string, { is_single_request_initiation?: boolean }>)
      .filter(tag => tag.is_single_request_initiation === true);
    this.filtered_custom_tags = filteredTags;
    this.updateAvailableOptions()
    this.loadCountryData();
    this.getRequestForShopId()    
    this.validateForm(); 

  }
  getRequestForShopId() {
    this.params['brand_id'] = this.brandDetails._id;
    // console.log(this.params);
    this._outboxService.getListForSentTab(this.params).subscribe(
      (response) => {
        this.shopId = response.data['shops'][0]['_id']
        this.app_id = response.data['shops'][0]['app_id']
      },
      (error) => {
        console.log(error);
      }
    );
  }
  toggleChannel(channel: string) {
    const previousSelection = new Set(this.selectedRequestChannels);
    if (channel === 'All') {
      this.selectedRequestChannels = this.selectedRequestChannels.includes('All') ? [] : ['All', 'SMS', 'Email', 'WA'];
    } else {
      const index = this.selectedRequestChannels.indexOf(channel);
      if (this.selectedRequestChannels.length === 1 && index === 0) {
        Helpers.smallAlertBox('', "Please select at least one Request channel(s).", "error");
        return;
      }
  
      if (index > -1) {
        this.selectedRequestChannels.splice(index, 1);
      } else {
        this.selectedRequestChannels.push(channel);
      }
      const allSelected = ['SMS', 'Email', 'WA'].every(ch => this.selectedRequestChannels.includes(ch));
      this.selectedRequestChannels = allSelected ? ['All', ...this.selectedRequestChannels] : this.selectedRequestChannels.filter(ch => ch !== 'All');
    }
  
    // Reset input fields when a channel is deselected
    if (!this.selectedRequestChannels.includes(channel)) {
      switch (channel) {
        case 'SMS':
          if (this.mobileSMSRef?.nativeElement) this.mobileSMSRef.nativeElement.value = "";
          break;
        case 'WA':
          if (this.mobileWARef?.nativeElement) {
            this.mobileWARef.nativeElement.value = "";
            this.formData.isSameNumberWA = false;
          }
          break;
        case 'Email':
          if (this.emailRef?.nativeElement) this.emailRef.nativeElement.value = "";
          break;
      }
    } 
  // If SMS is OFF, but WA is still ON and Same number checkbox was true, reset related fields
if (!this.selectedRequestChannels.includes('SMS') && this.selectedRequestChannels.includes('WA') && this.formData.isSameNumberWA) {
  this.formData.isSameNumberWA = false;

  if (this.mobileWARef?.nativeElement) {
    this.mobileWARef.nativeElement.value = "";
  }

  this.selectedCountryWA = {
    name: "India",
    code: "IN",
    dial_code: "+91",
    pattern: "^\\d{10}$",
    max_limit: 10
  };
}

    // this.validateForm();
    // // this.isFormValid = false
    // // **Force UI update immediately**
    // if (JSON.stringify(Array.from(previousSelection)) !== JSON.stringify(this.selectedRequestChannels)) {
    //   this.cdRef.detectChanges();
    // }
    this.validateForm()
  }

  syncNumbers() {
    if (this.sameNumberWARef.nativeElement.checked) {
      this.mobileWARef.nativeElement.value = this.mobileSMSRef.nativeElement.value;
    } else {
      this.mobileWARef.nativeElement.value = '';
    }
  }

  toggleWASameAsPhone() {
        this.formData.isSameNumberWA = !this.formData.isSameNumberWA;
    if (this.formData.isSameNumberWA && this.mobileWARef?.nativeElement && this.mobileSMSRef?.nativeElement?.value) {
      this.mobileWARef.nativeElement.value = this.mobileSMSRef?.nativeElement?.value?.trim();
      this.selectedCountryWA = this.selectedCountrySMS;
    } else if(!this.formData.isSameNumberWA) {
      this.selectedCountryWA = { name: "India", code: "IN", dial_code: "+91", pattern: "^\\d{10}$", max_limit: 10 }
      this.mobileWARef.nativeElement.value = ""
    }
    this.validateForm();
  }
  
  
  
  
  loadCountryData() {
    this.http.get<any[]>('assets/json/countries.json').subscribe(
      (data) => this.countries = data,
      (error) => console.error("Error loading country data:", error)
    );
  }

  isDropdownOpen(header: string): boolean {
    return this.dropdownFocusState[header];
  }

  setSelectedCountry(event: any, channel: string) {
    const selectedCode = event.target.value;
    const selectedCountry = this.countries.find(c => c.code === selectedCode);
    if (channel === 'SMS') {
      this.selectedCountrySMS = selectedCountry;
      if(this.formData.isSameNumberWA){
        this.selectedCountryWA = this.selectedCountrySMS;
      }
    } else if (channel === 'WA') {
      this.selectedCountryWA = selectedCountry;
    }
  }
  updateAvailableOptions() {

    this.tagLength = this.filtered_custom_tags.length; // Store original length to avoid early disable
    this.selectedTags = this.transactionDatas.map(td => td.tagName).filter(name => name);
    this.touchpointOptions = this.filtered_custom_tags
      .map(tag => tag.name)
      .filter(name => !this.selectedTags.includes(name)); // Exclude selected values
  }



  selectOption(option: string, index: number) {
    this.transactionDatas[index].tagName = option;
    this.showDropdown[index] = false;
    this.updateAvailableOptions();
  }

  addTransactionData() {
    if (this.transactionDatas.length < this.tagLength) { // Use original tagLength instead of dynamic length
      this.transactionDatas.push({ tagName: '', tagValue: '' });
      this.showDropdown.push(false);
      console.log(this, this.transactionDatas, "formattedTags");

    }
  }

  isAddTransactionElabled() {
    let isValid = true;
    this.transactionDatas.forEach(item => {
      if (item.tagName === "") {
        isValid = false;
      } 
    })
    if (this.transactionDatas.length >= this.tagLength) {
      isValid = false;
    }
    return isValid;
  }


  removeTransactionData(index: number) {
    this.transactionDatas.splice(index, 1);
    this.showDropdown.splice(index, 1);
    this.updateAvailableOptions();
  }

  toggleDropdown(index: number) {
    this.showDropdown[index] = !this.showDropdown[index];
  }


  addCustomTag() {
    this.customTags.push({ tagName: '', tagValue: '' });
  }

  isAddCustomTagElabled(): boolean {
    return this.customTags.every(item =>
      item.tagName !== "" && this.isValidTagData(item.tagName) && item.tagValue !== "" && this.isValidTagData(item.tagValue)
    );
  }
  


  isValidTagData(tagName: string): boolean {
    // const validTagPattern = /^[a-zA-Z0-9!@#$%^&()_{}:“?`-‘,./\\ ]+$/; // Allowed characters
    const validTagPattern = /^[a-zA-Z0-9!@#$%^&()_{}\:“\?`\-‘,./\\'"]+$/;
    const word = tagName.trim();
    const words = word.split(' ');
    return words.every((word: string) => validTagPattern.test(word)) && word.length > 0;
  }

  removeCustomTag(index: number) {
    this.customTags.splice(index, 1);
  }
  clearSelection() {
    this.transactionDatas = [{ tagName: '', tagValue: '' }];
    this.updateAvailableOptions();
  }
  clearCustomTags() {
    this.customTags = [{ tagName: '', tagValue: '' }];
    this.isRestrictedSpecialCharacter = false;  // Clear special character restriction error
    this.isTagDataEnglish = true;  // Reset English character validation flag
  }

  isClearSelectionActive(tagName){
    if (tagName == "customTag" && this.customTags.length) {
      if (this.customTags.length > 1 || this.customTags[0].tagName != "" || this.customTags[0].tagValue != ""){
        return true;
      } else {
        return false;
      }
    } else if (tagName == "transactionData" && this.transactionDatas.length){
      if (this.transactionDatas.length > 1 || this.transactionDatas[0].tagName != "" || this.transactionDatas[0].tagValue != ""){
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  postRequest(data) {
    const token = "litmusworld_internal"
     // this.reCAPTCHAToken = `Token [${token}] generated`;
     data.g_recaptcha_response_v3 = token
    // const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.addSingleRequest);
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.validateUserAndCreateRequest);
    this._utilsService.postAPICall(url, data, this._utilsService.setHeaders()).subscribe(
      (response) => {
        this.resetForm()
        this.requestCreationComponent.closeNewRequestPanel();
        const successMsg = "Form Submitted successfully"
        if(response?.data?.code == 0){
          this._toast.showPopup('SUCCESS', 'Success', "A New Request has been successfully generated", 5000);
        } else {
          this._toast.showPopup('ERROR', 'Error', 'Error occured while generating request', 5000);
        }
      },
      (error) => {
        this._toast.showPopup('ERROR', 'Error', 'Unable to connect the server', 7000);
        console.error('Error in API call in CheckLogin:', error);
      }
     );   
}

// postRequestV2 is created to generate and validate recaptcha.
  postRequestV2(data) {
    this.recaptchaV3Service.execute('importantAction').subscribe((token: string) => {
     // this.reCAPTCHAToken = `Token [${token}] generated`;
     data.g_recaptcha_response_v3 = token
    // const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.addSingleRequest);
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.validateUserAndCreateRequest);
    this._utilsService.postAPICall(url, data, this._utilsService.setHeaders()).subscribe(
      (response) => {
        // console.log(response)
        this.resetForm()
        this.requestCreationComponent.closeNewRequestPanel();
        const successMsg = "Form Submitted successfully"
        if(response?.data?.code == 0){
          this._toast.showPopup('SUCCESS', 'Success', "A New Request has been successfully generated", 5000);
        } else {
          this._toast.showPopup('ERROR', 'Error', 'Error occured while generating request', 5000);
        }
      },
      (error) => {
        this._toast.showPopup('ERROR', 'Error', 'Unable to connect the server', 7000);
        console.error('Error in API call in CheckLogin:', error);
      }
     );
    });    
}

  postRequestForTokenization(data) {
    const url = _.get(Helpers.brandDetails, "security_settings.tokenization_server.generate_token_url", null);
    if(url && url !== null){
      data['is_external_api'] = true;
      this._utilsService.postAPICall(url, data, this._utilsService.setHeaders()).subscribe(
        (response) => {
          // console.log(response)
          this.resetForm()
          this.requestCreationComponent.closeNewRequestPanel();
          const successMsg = "Form Submitted successfully"
          if(response?.data?.code == 0){
            this._toast.showPopup('SUCCESS', 'Success', "A New Request has been successfully generated", 5000);
          } else {
            this._toast.showPopup('ERROR', 'Error', 'Error occured while generating request', 5000);
          }
        },
        (error) => {
          this._toast.showPopup('ERROR', 'Error', 'Unable to connect the server', 7000);
          console.error('Error in API call in CheckLogin:', error);
        }
      );
    }else{
      this._toast.showPopup('ERROR', 'Error', 'Tokenization API URL not found', 5000);
    }
  }

  // Method to check for ASCII characters
  checkForAscii(stringToCheck: string): boolean {
    if (stringToCheck == undefined) {
      return true;
    }
    const englishAlphabetAndWhiteSpace = /[ -~]/;
    for (let i = 0; i < stringToCheck.length; i++) {
      if (!englishAlphabetAndWhiteSpace.test(stringToCheck[i])) {
        return false;
      }
    }
    return true;
  }

  // Method to check for special characters
  checkForSpecialExceptionCharacters(stringToCheck: string): boolean {
    if (stringToCheck !== undefined && stringToCheck !== null) {
      return [
        '&lt;', '&gt;', ';', '<', '>', '+', '~', '[]', '[', ']', '|', '=','*'
      ].some(char => stringToCheck.includes(char));
    }
    return false;
  }
  
  // Method to restrict non-English characters
  restrictNonEnglish($index: number) {
    // const key = String.fromCharCode(event.which);
    const cstagName = this.customTags[$index]['tagName'];
    const cstagValues = this.customTags[$index]['tagValue'];
    const tag = this.customTags[$index];

    tag.tagName = this.convertHtmlEntities(tag.tagName);
    tag.tagValue = this.convertHtmlEntities(tag.tagValue);
    // Check for special characters in tag name or value
    if (this.checkForSpecialExceptionCharacters(cstagName) || this.checkForSpecialExceptionCharacters(cstagValues)) {
      this.isRestrictedSpecialCharacter = true;
    } else {
      this.isRestrictedSpecialCharacter = false;
    }    

    // Check if both the custom tag name and values contain only ASCII characters
    if (this.checkForAscii(cstagName) && this.checkForAscii(cstagValues)) {
      this.isTagDataEnglish = true;
    } else {
      this.isTagDataEnglish = false;
    }
    this.validateForm()
  }

  // Display warnings if there are issues with the request form
  restrictNonEnglishWarningMessage(): void {
    const errors: string[] = [];
    if (this.isRestrictedSpecialCharacter && !this.isTagDataEnglish) {
      errors.push('Custom tag data can only be in English characters and have only valid special characters.');
      Helpers.smallAlertBox(errors.join('<br>'), '', 'error', 3000);
    } else if (this.isRestrictedSpecialCharacter) {
      errors.push('Please enter only valid characters');
      Helpers.smallAlertBox(errors.join('<br>'), '', 'error', 3000);
    } else if (!this.isTagDataEnglish) {
      errors.push('Custom tag data can only be in English characters');
      Helpers.smallAlertBox(errors.join('<br>'), '', 'error', 3000);
    }
  }
  convertHtmlEntities(value: string): string {
    return value.replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  
  validateForm() {
    this.isFormValid = false
    const name = this.nameRef?.nativeElement?.value?.trim() || '';
    const mobileSMS = this.mobileSMSRef?.nativeElement?.value?.trim() || '';
    const email = this.emailRef?.nativeElement?.value?.trim() || '';
    const wa = this.mobileWARef?.nativeElement?.value?.trim() || '';

    const isValidName = /^[a-zA-Z0-9_\- ]*$/.test(name);
    const isValidMobile = new RegExp(this.selectedCountrySMS?.pattern).test(mobileSMS); // Check if mobile number is exactly 10 digits
    const isValidWhatsapp = new RegExp(this.selectedCountryWA?.pattern).test(wa);
    const isValidEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email); // Email validation regex
    const actualChannels = this.selectedRequestChannels.filter(ch => ch !== 'All');
    const hasChannelSelected = actualChannels.length > 0;
    let isValidChannel = true;
   
    this.selectedRequestChannels.forEach(channel => {      
      if (channel === 'SMS' && !isValidMobile) {
        isValidChannel = false;
      } else if (channel === 'Email' && !isValidEmail) {
        isValidChannel = false;
      } else if (channel === 'WA' && !isValidWhatsapp) {
        isValidChannel = false;
      }
    });

      if (name && !isValidName) {
        this.nameError = "Special characters are not allowed in Name";
      } else {
        this.nameError = '';
      }
    // Mobile number validation
   if (mobileSMS && !isValidMobile) {
      this.mobileNumberError = "Phone number is invalid";
    } else {
      this.mobileNumberError = ''; // Clear the error if valid
    }

    // Email validation
    if (email && !isValidEmail) {
      this.emailError = "Email Id is invalid";
    } else {
      this.emailError = ''; // Clear the error if valid
    }
    if (wa && !isValidWhatsapp && !this.formData.isSameNumberWA) {
      this.whatsappNumberError = "WhatsApp number is invalid";
    } else {
      this.whatsappNumberError = ''; 
    }
    if (this.formData.isSameNumberWA && this.mobileWARef?.nativeElement && this.mobileSMSRef?.nativeElement?.value) {
      this.mobileWARef.nativeElement.value = this.mobileSMSRef?.nativeElement?.value?.trim();
    }
    this.isFormValid = (isValidName && isValidChannel && hasChannelSelected && !this.isRestrictedSpecialCharacter && this.isTagDataEnglish);
  }


  submitRequest() {
    const name = this.nameRef?.nativeElement?.value || '';
    const mobileSMS = this.mobileSMSRef?.nativeElement?.value || '';
    const mobileWA = this.formData.isSameNumberWA ? mobileSMS : this.mobileWARef?.nativeElement?.value || '';
    const email = this.emailRef?.nativeElement?.value || null;
    const isWhatsAppSame = this.formData.isSameNumberWA || false;
    const isExcludedFromAnalytics = (document.querySelector('input[type="checkbox"]:checked') as HTMLInputElement)?.checked || false;

    let missingFields: string[] = [];

    if (!name) {
      missingFields.push("Name");
    }
    // if (!mobileSMS) {
    //   missingFields.push("Mobile SMS");
    // }
    if (missingFields.length > 0) {
      const errorMessage = `${missingFields.join(" and ")} ${missingFields.length > 1 ? "are" : "is"} required.`;
      this._toast.showPopup('ERROR', 'Validation Error', errorMessage, 7000);
      return;
    }
    const dynamicTags: { [key: string]: string } = {};

    if (this.transactionDatas && Array.isArray(this.transactionDatas)) {
      this.transactionDatas.forEach(tag => {
        if (tag.tagName && typeof tag.tagName === "string" && tag.tagName.trim()) {
          if (tag.tagName.trim().match(/^tag_/i)) {
            dynamicTags[tag.tagName.trim().replace(/ /g, '_').toLowerCase()] = tag.tagValue;
          } else {
            dynamicTags[`tag_${tag.tagName.trim().replace(/\s+/g, '_').toLowerCase()}`] = tag.tagValue;
          }
        }
      });
    }

    // Convert custom tags into key-value pairs
    const formattedTags: { [key: string]: string } = {};

    if (this.customTags && Array.isArray(this.customTags)) {
      this.customTags.forEach(tag => {
        if (tag.tagName && typeof tag.tagName === "string" && tag.tagName.trim()) {
          if (tag.tagName.trim().match(/^tag_/i)) {
            formattedTags[tag.tagName.trim().replace(/\s+/g, '_').toLowerCase()] = tag.tagValue;
          } else {
            formattedTags[`tag_${tag.tagName.trim().replace(/\s+/g, '_').toLowerCase()}`] = tag.tagValue;
          }
        }
      });
    }

    // Construct expected payload
    let requestData = {
      name,
      notify_channel: this.selectedRequestChannels.length === 3 ? "all" : this.selectedRequestChannels,
      shopId: this.shopId,
      app_id:this.app_id,
      userEmail: email,
      // userPhone: `${this.selectedCountry.dial_code}${mobileSMS}`,
      // userWhatsapp: `${this.selectedCountry.dial_code}${mobileWA}`,
      is_excluded_from_analytics: this.isExcludedFromStatistics,
      request_mode : this.request_mode, 
      is_whatsapp_number_same_as_phone_number: isWhatsAppSame,
      ...dynamicTags,
      ...formattedTags,
    };
    if (mobileWA && mobileWA != "") {
      requestData['userWhatsapp'] = `${this.selectedCountryWA.dial_code}${mobileWA}`;
    } else {
      requestData['userWhatsapp'] = null;
    }
    if (mobileSMS && mobileSMS != "") {
      requestData['userPhone'] = `${this.selectedCountrySMS.dial_code}${mobileSMS}`;
    } else {
      requestData['userPhone'] = null;
    }
    // console.log("Updated Request Payload:", requestData);
    const is_tokenization_project = _.get(Helpers.brandDetails, "security_settings.tokenization_server.secret_key")
    if(!_.isEmpty(is_tokenization_project) && is_tokenization_project !== undefined){
      this.postRequestForTokenization(requestData);
    }else{
      this.postRequest(requestData);  
    }
    this.resetForm();
  }
  resetForm() {
    if (this.nameRef) this.nameRef.nativeElement.value = '';
    if (this.mobileSMSRef) this.mobileSMSRef.nativeElement.value = '';
    if (this.mobileWARef) this.mobileWARef.nativeElement.value = '';
    if (this.emailRef) this.emailRef.nativeElement.value = '';
    // if (this.sameNumberWARef) this.sameNumberWARef.nativeElement.checked = false;
    this.formData.isSameNumberWA = false;
    this.transactionDatas = [{ tagName: '', tagValue: '' }];
    this.customTags = [{ tagName: '', tagValue: '' }];
    this.selectedRequestChannels = ['SMS', 'Email', 'WA'];
    this.updateAvailableOptions();
    this.isExcludedFromStatistics = false;
    this.isTagDataEnglish = true;
    this.isRestrictedSpecialCharacter = false;
    this.emailError = "";
    this.mobileNumberError = "";
    this.whatsappNumberError = "";
    this.isFormValid = false
    // Close Modal (if using Bootstrap or Material)
    // if (this.modalRef) {
    //   (this.modalRef.nativeElement as any).modal('hide'); // For Bootstrap
    //   // this.modalRef.nativeElement.close(); // If using Angular Material Dialog
    // }
  }

  toggleExcludeFromStatistics(event: Event) {
    this.isExcludedFromStatistics = (event.target as HTMLInputElement).checked;
  }

  cancelRequest() {
    this.resetForm()
    this.requestCreationComponent.closeNewRequestPanel();
  }
}
